import { render } from "./Lesson.vue?vue&type=template&id=e36c7afe"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/lessons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__